import React from "react";
import MetricCard from "./graphs/MetricCard";
import "../../styles/superAdmin/addClient.css";

const StatsWidgets = ({ clientStats }) => {
  return (
    <>
       <div className="ad_client_metric_card_container">
        <MetricCard
          icon="/assets/superAdmin/card1.svg"
          value={clientStats?.payload?.total_clients}
          title="Total Clients"
        />
      </div>
      <div className="ad_client_metric_card_container">
        <MetricCard
          icon="/assets/superAdmin/card4.svg"
          value={clientStats?.payload?.new_users}
          title="New Clients"
        />
      </div>
   
      <div className="ad_client_metric_card_container">
        <MetricCard
          icon="/assets/superAdmin/card3.svg"
          value={clientStats?.payload?.total_modules}
          title="Total Modules"
        />
      </div>
    </>
  );
};

export default StatsWidgets;
